export default (length = 5) => {
  let randomId = '';
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (let i = 0; i < length; i += 1) {
    randomId += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return randomId;
};
